/* CLAIRENCE : filtres de collection (disponibilite, prix, matiere, couleur), pensés pour le mobile.
   Lit les attributs data-* poses par snippets/product-card.liquid. Filtre les produits deja affiches : la collection doit tenir sur une page (24 produits). */
(function () {
  "use strict";
  var grid = document.querySelector(".product-grid");
  var toolbar = document.querySelector(".collection-toolbar");
  if (!grid || !toolbar) { return; }
  var cards = [].slice.call(grid.querySelectorAll(".product-card"));
  if (cards.length < 3) { return; }
  var countEl = document.querySelector(".collection-count");
  var total = cards.length;

  var PRICES = [
    { id: "p1", label: "Moins de 500 €", min: 0, max: 50000 },
    { id: "p2", label: "500 à 1 000 €", min: 50000, max: 100000 },
    { id: "p3", label: "1 000 à 1 500 €", min: 100000, max: 150000 },
    { id: "p4", label: "Plus de 1 500 €", min: 150000, max: Infinity }
  ];
  var S = { stock: false, price: [], mat: [], col: [] };

  function priceOf(c) { return parseInt(c.getAttribute("data-price"), 10) || 0; }
  function colsOf(c) { return (c.getAttribute("data-colors") || "").split("|").filter(Boolean); }
  function matOf(c) { return c.getAttribute("data-material") || ""; }
  function range(id) { return PRICES.filter(function (p) { return p.id === id; })[0]; }

  function matches(c) {
    if (S.stock && c.getAttribute("data-available") !== "true") { return false; }
    if (S.price.length) {
      var pr = priceOf(c);
      if (!S.price.some(function (id) { var r = range(id); return pr >= r.min && pr < r.max; })) { return false; }
    }
    if (S.mat.length && S.mat.indexOf(matOf(c)) < 0) { return false; }
    if (S.col.length) {
      var cs = colsOf(c);
      if (!S.col.some(function (x) { return cs.indexOf(x) > -1; })) { return false; }
    }
    return true;
  }

  /* Valeurs disponibles, dans l'ordre d'apparition */
  function uniq(list) { return list.filter(function (v, i) { return v && list.indexOf(v) === i; }); }
  var mats = uniq(cards.map(matOf));
  var cols = uniq([].concat.apply([], cards.map(colsOf)));
  var prices = PRICES.filter(function (p) { return cards.some(function (c) { var x = priceOf(c); return x >= p.min && x < p.max; }); });
  var hasOut = cards.some(function (c) { return c.getAttribute("data-available") !== "true"; });

  /* Interface */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text) { n.textContent = text; }
    return n;
  }

  var btn = el("button", "cl-filter-btn");
  btn.type = "button";
  btn.appendChild(document.createTextNode("Filtrer"));
  var badge = el("span", "cl-filter-btn__n");
  badge.hidden = true;
  btn.appendChild(badge);
  toolbar.insertBefore(btn, toolbar.firstChild);

  var sheet = el("div", "cl-fs");
  sheet.hidden = true;
  var overlay = el("div", "cl-fs__overlay");
  var panel = el("aside", "cl-fs__panel");
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-modal", "true");
  panel.setAttribute("aria-label", "Filtrer les produits");
  var head = el("div", "cl-fs__head");
  head.appendChild(el("h2", "cl-fs__title", "Filtrer"));
  var closeBtn = el("button", "cl-fs__close", "×");
  closeBtn.type = "button";
  closeBtn.setAttribute("aria-label", "Fermer");
  head.appendChild(closeBtn);
  var body = el("div", "cl-fs__body");
  var foot = el("div", "cl-fs__foot");
  var resetBtn = el("button", "btn btn-outline", "Tout effacer");
  resetBtn.type = "button";
  var applyBtn = el("button", "btn btn-primary", "Voir les produits");
  applyBtn.type = "button";
  foot.appendChild(resetBtn);
  foot.appendChild(applyBtn);
  panel.appendChild(head);
  panel.appendChild(body);
  panel.appendChild(foot);
  sheet.appendChild(overlay);
  sheet.appendChild(panel);
  document.body.appendChild(sheet);

  var chips = [];
  function group(title, items, key, single) {
    if (!items.length) { return; }
    var g = el("div", "cl-fs__group");
    g.appendChild(el("h3", "cl-fs__gtitle", title));
    var wrap = el("div", "cl-fs__chips");
    items.forEach(function (it) {
      var c = el("button", "cl-fs__chip", it.label);
      c.type = "button";
      c.setAttribute("aria-pressed", "false");
      c.addEventListener("click", function () {
        if (single) {
          S[key] = !S[key];
        } else {
          var i = S[key].indexOf(it.id);
          if (i > -1) { S[key].splice(i, 1); } else { S[key].push(it.id); }
        }
        render();
      });
      chips.push({ node: c, key: key, id: it.id, single: single });
      wrap.appendChild(c);
    });
    g.appendChild(wrap);
    body.appendChild(g);
  }
  if (hasOut) { group("Disponibilité", [{ id: "stock", label: "En stock uniquement" }], "stock", true); }
  group("Prix", prices.map(function (p) { return { id: p.id, label: p.label }; }), "price");
  group("Matière", mats.map(function (m) { return { id: m, label: m }; }), "mat");
  group("Couleur", cols.map(function (c) { return { id: c, label: c }; }), "col");

  var empty = el("div", "cl-filter-empty");
  empty.hidden = true;
  empty.appendChild(el("p", "", "Aucun produit ne correspond à ces filtres."));
  var emptyBtn = el("button", "btn btn-outline", "Effacer les filtres");
  emptyBtn.type = "button";
  empty.appendChild(emptyBtn);
  grid.appendChild(empty);

  function activeCount() { return (S.stock ? 1 : 0) + S.price.length + S.mat.length + S.col.length; }

  function render() {
    var shown = 0;
    cards.forEach(function (c) {
      var ok = matches(c);
      c.hidden = !ok;
      if (ok) { shown++; }
    });
    chips.forEach(function (c) {
      var on = c.single ? S[c.key] : S[c.key].indexOf(c.id) > -1;
      c.node.setAttribute("aria-pressed", on ? "true" : "false");
    });
    var n = activeCount();
    badge.textContent = String(n);
    badge.hidden = n === 0;
    applyBtn.textContent = "Voir " + shown + " produit" + (shown > 1 ? "s" : "");
    if (countEl) { countEl.textContent = shown + " produit" + (shown > 1 ? "s" : "") + (n ? " sur " + total : ""); }
    empty.hidden = shown !== 0;
  }

  function reset() { S.stock = false; S.price = []; S.mat = []; S.col = []; render(); }

  function openSheet() { sheet.hidden = false; document.body.style.overflow = "hidden"; closeBtn.focus(); }
  function closeSheet() { sheet.hidden = true; document.body.style.overflow = ""; btn.focus(); }

  btn.addEventListener("click", openSheet);
  closeBtn.addEventListener("click", closeSheet);
  overlay.addEventListener("click", closeSheet);
  applyBtn.addEventListener("click", closeSheet);
  resetBtn.addEventListener("click", reset);
  emptyBtn.addEventListener("click", reset);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !sheet.hidden) { closeSheet(); } });

  render();
})();